/**
 * External dependencies
 */
import React, { useState } from 'react';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import { get, map, noop } from 'lodash';
import { connect } from 'react-redux';

/*
 * Internal dependencies
 */
import ConnectionInputRow from 'modules/dashboard/connections/connection-input-row';

/**
 * Style dependencies
 */
import './styles.scss';

const EditApiConfig = ({ onChange = noop, connection, defaultValues, connectionType, ...props }) => {
	if (!connection || !connectionType) {
		return null;
	}

	const [values, setValues] = useState(defaultValues || {});

	const handleOnChange = (e) => {
		let a = {
			...values,
		};
		a[e.target.name] = e.target.value;
		setValues(a);
		onChange({ ...a });
	};

	const inputFieldsMarkup = map(get(connectionType, 'default_connection_config'), (v, k) => {
		if(connectionType.code == "shopify_graphql") {
			//if(k!="ApiKey" && k!="SharedSecret") {
			if(k=="ApiKey") {
				return (
					<ConnectionInputRow
						key={k}
						connectionTypeCode={connectionType.code}
						k={k}
						label='Client Id'
						value={get(values, k)}
						handleOnChange={handleOnChange}
					/>
				);
			} else {
				return (
					<ConnectionInputRow
						key={k}
						connectionTypeCode={connectionType.code}
						k={k}
						label={v}
						value={get(values, k)}
						handleOnChange={handleOnChange}
					/>
				);
			}
		} else {
			return (
				<ConnectionInputRow
					key={k}
					connectionTypeCode={connectionType.code}
					k={k}
					label={v}
					value={get(values, k)}
					handleOnChange={handleOnChange}
				/>
			);
		}
	});

	return (
		<Box>
			<Stack space='large'>{inputFieldsMarkup}</Stack>
		</Box>
	);
};

export default connect((state, ownProps) => {
	return {
		connectionType: get(state, ['connectionTypes', 'items', get(ownProps, 'connection.connection_type_id')]),
	};
}, {})(EditApiConfig);
